import { initReactI18next } from 'react-i18next'

import { loadLanguageResources, numberToWords } from 'helpers'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(LanguageDetector)
  .use({
    type: 'backend',
    read: async (lng, ns, callback) => {
      try {
        const resource = await loadLanguageResources(lng)
        callback(null, resource[ns])
      } catch (err) {
        callback(err, null)
      }
    },
  })
  .use(initReactI18next)
  .init({
    detection: {
      order: ['navigator'],
    },
    load: 'languageOnly',
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((err) => console.error('i18n initialization failed:', err))

i18n.services.formatter?.addCached(
  'numberToWords',
  () => (val) => numberToWords(val),
)
